import React, { ForwardedRef, forwardRef } from 'react';
import withCx, { CxProps } from 'fe-core/util/withCx';
import MaskedTextInput from 'fe-design-base/atoms/MaskedTextInput';
import { TextInputProps } from 'fe-design-base/atoms/TextInput';

export interface TaxIdInputProps extends TextInputProps {
  isEIN?: boolean;
  stripChars?: boolean;
  uxElement?: string;
}

const TaxIdInput = forwardRef(
  (
    {
      cx,
      isEIN,
      uxElement,
      stripChars = true,
      name,
      label,
      ...otherProps
    }: TaxIdInputProps & CxProps,
    ref: ForwardedRef<any>
  ) => {
    const SSN_MASK = [
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];

    const EIN_MASK = [
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];

    const STRIP_CHARS = [/-/g, /\s/g];

    const mask = isEIN ? EIN_MASK : SSN_MASK;
    const placeholderMask = mask
      .map((maskChar: any) => (typeof maskChar === 'string' ? maskChar : '_'))
      .join('');

    return (
      <MaskedTextInput
        className={cx()}
        ref={ref}
        mask={mask}
        stripChars={stripChars ? STRIP_CHARS : undefined}
        name={name}
        label={label}
        uxElement={uxElement}
        placeholder={placeholderMask}
        {...otherProps}
      />
    );
  }
);

export default withCx<TaxIdInputProps>('FDBTaxIdInput')(TaxIdInput);
